import { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "./AuthContext";

const NotificationContext = createContext(null);

export const useNotifications = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) return { pendingApprovals: 0, pendingNotes: 0, unreadNotifications: 0, totalCount: 0, refresh: () => {} };
  return ctx;
};

export const NotificationProvider = ({ children }) => {
  const { authAxios, user } = useAuth();
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [pendingNotes, setPendingNotes] = useState(0);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const intervalRef = useRef(null);

  const fetchCounts = useCallback(async () => {
    if (!user) return;
    try {
      const api = authAxios();
      const res = await api.get("/notifications/count");
      setPendingApprovals(res.data.pending_approvals || 0);
      setPendingNotes(res.data.pending_notes || 0);
      setUnreadNotifications(res.data.unread_notifications || 0);
    } catch {
      // Silently fail
    }
  }, [authAxios, user]);

  useEffect(() => {
    fetchCounts();
    intervalRef.current = setInterval(fetchCounts, 30000);
    return () => clearInterval(intervalRef.current);
  }, [fetchCounts]);

  const totalCount = pendingApprovals + pendingNotes + unreadNotifications;

  return (
    <NotificationContext.Provider value={{ pendingApprovals, pendingNotes, unreadNotifications, totalCount, refresh: fetchCounts }}>
      {children}
    </NotificationContext.Provider>
  );
};
